(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["main-nav"]) return;
  try {
    
var announcementPreviousButton, announcementNextButton;
var announcementSlider, announcementSlides;
var leftMostAnnouncementSlideIndex = 0;

window.addEventListener('DOMContentLoaded', function(e) {
  announcementPreviousButton = document.getElementById('announcement-slider-previous');
  announcementNextButton = document.getElementById('announcement-slider-next');
  announcementSlider = document.getElementById('announcement-slider');
  announcementSlides = announcementSlider.querySelectorAll('li');

  // Set up previous/next button behaviors
  if(announcementPreviousButton) {
    announcementPreviousButton.addEventListener('click', previousAnnouncementSlide);
  }
  if(announcementNextButton) {
    announcementNextButton.addEventListener('click', nextAnnouncementSlide);
  }
  
  // Ensure that all non-visible slides are impossible to reach.
  hideNonVisibleAnnouncementSlides();
});
/** Go to previous slide */
function previousAnnouncementSlide() {
  if(leftMostAnnouncementSlideIndex > 0) {
    goToAnnouncementSlide(leftMostAnnouncementSlideIndex - 1);
  } else {
    goToAnnouncementSlide(announcementSlides.length - 1);
  }
}

/** Go to next slide */
function nextAnnouncementSlide() {
  if(leftMostAnnouncementSlideIndex < announcementSlides.length - 1) {
    goToAnnouncementSlide(leftMostAnnouncementSlideIndex + 1);
  } else {
    goToAnnouncementSlide(0);
  }
}

/** Go to a specific slide */
function goToAnnouncementSlide(nextLeftMostAnnouncementSlideIndex) {
  
  // Update the record of the left-most slide
  leftMostAnnouncementSlideIndex = nextLeftMostAnnouncementSlideIndex;
  
  // Update each slide so that the ones that are now off-screen are fully hidden.
  hideNonVisibleAnnouncementSlides();
}
/**
  Fully hide non-visible slides by adding aria-hidden="true" and tabindex="-1" when they go out of view
*/
function hideNonVisibleAnnouncementSlides() {
  if(announcementSlides.length > 1) {
    // Start by hiding all the slides and their content
    announcementSlides.forEach(function(slide) {
      slide.setAttribute('aria-hidden', true);
      
      slide.querySelectorAll('a, button, select, input, textarea, [tabindex="0"]').forEach(function(focusableElement) {
        focusableElement.setAttribute('tabindex', -1);      
      });
    });
    
    if(leftMostAnnouncementSlideIndex < announcementSlides.length) {
      for(var i = leftMostAnnouncementSlideIndex; i < leftMostAnnouncementSlideIndex + 1; i++) {
        announcementSlides[i].removeAttribute('aria-hidden');
        
        announcementSlides[i].querySelectorAll('a, button, select, input, textarea, [tabindex="0"]').forEach(function(focusableElement) {
          focusableElement.removeAttribute('tabindex');      
        });
      }
      
    } else {
      for(var i = 1; i < announcementSlides.length; i++) {
        announcementSlides[i].removeAttribute('aria-hidden');
        
        announcementSlides[i].querySelectorAll('a, button, select, input, textarea, [tabindex="0"]').forEach(function(focusableElement) {
          focusableElement.removeAttribute('tabindex');      
        });
      }
    }
  }
}
UIkit.util.on('#announcement-slider-container', 'itemshown', function () {
  announcementSlides.forEach(function(slide) {
    slide.setAttribute('aria-hidden', true);
    
    slide.querySelectorAll('a, button, select, input, textarea, [tabindex="0"]').forEach(function(focusableElement) {
      focusableElement.setAttribute('tabindex', -1);      
    });
  });
  
	announcementSlides[UIkit.slider('#announcement-slider-container').index].removeAttribute('aria-hidden');
  
  announcementSlides[UIkit.slider('#announcement-slider-container').index].querySelectorAll('a, button, select, input, textarea, [tabindex="0"]').forEach(function(focusableElement) {
    focusableElement.removeAttribute('tabindex');      
  });
});

  } catch(e) { console.error(e); }
})();

})();
